export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://192.168.1.83:8080/api' : "/api"
// export const BASE_URL = "https://fabinsta.com/api"
// export const BASE_URL ="https://uat.fabinsta.com/api"